import React, {useState,useEffect} from "react";
import {Alert, Snackbar} from "@mui/material";

const SuccsMsg = ({message,openn,setsuccsmsg})=>{
    const [open , setOpen] = useState(true);
    useEffect(()=>{
        setOpen(openn)
    },open)
    const handlemsgclose = ()=>{
        setOpen(true);
        setsuccsmsg("");
    }
    return(
        <div>
            <Snackbar
                open={open}
                autoHideDuration={2500}
                onClose={handlemsgclose}
                anchorOrigin={{ vertical:"bottom", horizontal:"center" }}
            >
                <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </div>

    )

}
export default SuccsMsg